import { Dialog, Button, DialogContent, DialogActions, DialogContentText, Divider} from "@mui/material"
import { email, Form, required, TextInput, useGetIdentity, useGetOne, useNotify, usePermissions, useRefresh, useTranslate } from "react-admin"
import FormRow from "../../inputFormComponents/FormRow"
import { postCode } from "../../validators/validate"
import { AppId, OrderSubscriptionCommand, UpdateUserCommand } from "../../GeneratedClients/FreeBillApi"
import { Permissions } from "../../authentication/Permissions"
import { apiService } from "../../apiService"
import { Dispatch, SetStateAction } from "react"

const CompleteUserDataDialog = ({open, setOpen}: {open: boolean, setOpen: Dispatch<SetStateAction<boolean>>}) => {
  
  const translate = useTranslate()
  const {isLoading: permissionsLoading, permissions} = usePermissions<Permissions>()
  const { data: identity, isLoading } = useGetIdentity()
  const {data: user, isLoading: userIsLoading} = useGetOne("users", {id: identity?.id}, {enabled: !isLoading})
  const notify = useNotify()
  const refresh = useRefresh()

  if(permissionsLoading || isLoading || !identity || userIsLoading) return null

  const handleClose = () => {
    setOpen(false)
  }

  const handleSubmit = async(user: UpdateUserCommand) => {
    try {
      if(user?.id) {
        var location = window.location
        var callbackUrl = location.href
        var orderSubscriptionCommand: OrderSubscriptionCommand = {
          userId: user?.id,
          appId: permissions.redirectToFff ? AppId.Fff : AppId.Fbl,
          callbackUrl: callbackUrl,
          city: user?.company?.city,
          companyName: user?.company?.companyName,
          email: user?.company?.email,
          fullName: `${user?.contact?.firstName ? `${user?.contact?.firstName} ` : ""}${user?.contact?.lastName}`,
          postCode: user?.company?.postCode,
          streetNameAndNumber: user?.company?.street
        }
        await apiService.UsersApi.updateUser({id: user.id, updateUserCommand: user})
        var {data: url} = await apiService.UsersApi.orderSubscription({userId: user?.id, orderSubscriptionCommand: orderSubscriptionCommand })
        location.replace(url)
      }
    } catch (error: any) {
      handleClose()
      console.log(error)
      notify(`${error.response.data}`, {type: "error"})
      refresh()
    }
  }

  return (
    <>
      <Dialog 
        open={open} 
      >
        <Form record={user} onSubmit={handleSubmit}>
          <DialogContent>
            <DialogContentText>
              {translate('resources.users.message.notComplete')}
              <FormRow fields={[
                <TextInput fullWidth helperText={false} source="company.companyName" label="resources.company.userCompanyName" validate={required()} />
              ]}/>
              <FormRow fields={[
                <TextInput fullWidth helperText={false} source="company.street" label="resources.company.street" validate={required()} />,
              ]}/>
              <FormRow fields={[
                <TextInput sx={{minWidth:"24%"}} helperText={false} source="company.postCode" label="resources.company.postCode" validate={[required(), postCode()]} />,
                <TextInput sx={{ml:2}} fullWidth helperText={false} source="company.city" label="resources.company.city" validate={required()} />,
              ]}/>
              <Divider sx={{my:2}} />
              <FormRow fields={[
                <TextInput fullWidth helperText={false} source="contact.firstName" validate={required()} label="resources.contact.firstName" />,
                <TextInput sx={{ml:2}} fullWidth helperText={false} source="contact.lastName" validate={required()} label="resources.contact.lastName" />,
              ]}/>
              <FormRow fields={[
                <TextInput fullWidth helperText={false} source="contact.email" validate={[required(), email()]} label="resources.contact.email" />,
              ]}/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} >{translate('ra.action.cancel')}</Button>
            <Button type="submit" >Paket ändern</Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  )
}

export default CompleteUserDataDialog